import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const ClientNotFound = () => (
  <section>
    <header>
      <PageTitle>
        Client not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default ClientNotFound



// WEBPACK FOOTER //
// ./src/components/Clients/ClientNotFound.jsx